import { Editor } from 'grapesjs';
import { facThreeColumns } from '@qualifio/ui-commons';
import { EditorComponentDefinition } from '../types';
import { Toolbar } from '../../utils';

export const threeColumnsComponentDefinition: EditorComponentDefinition = {
  id: 'threeColumns',
  icon: facThreeColumns,
  category: 'Basic',
  getLabel: ({ t }) => t('editor.component.three-columns'),
  component: ThreeColumnsComponent,
};

export function ThreeColumnsComponent(editor: Editor) {
  const CLASSNAME = 'qlfeditor-columns';

  editor.DomComponents.addType(threeColumnsComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains(`${CLASSNAME}--3columns`);
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'Basic',
        components: [
          {
            type: 'column',
            removable: false,
            copyable: false,
            draggable: false,
            selectable: true,
            hoverable: false,
          },
          {
            type: 'column',
            removable: false,
            copyable: false,
            draggable: false,
            selectable: true,
            hoverable: false,
          },
          {
            type: 'column',
            removable: false,
            copyable: false,
            draggable: false,
            selectable: true,
            hoverable: false,
          },
        ],
        attributes: {
          class: `${CLASSNAME} ${CLASSNAME}--3columns`,
        },
        droppable: false,
        draggable: '[data-gjs-type=wrapper], [data-gjs-type=column]',
        traits: [],
      },
      initToolbar: Toolbar,
    },
  });
}
